import moment from 'moment-timezone'

export default (timestamp) => moment.utc(timestamp).local().format('YYYY-MM-DD')
